export class BaseLtiForm {
    constructor(public oauthConsumerKey: string,
        public oauthTimestamp: string){}
}